module.exports = __webpack_public_path__ + "static/media/lazyaz_app5.9219b034.jpg";